export default {
    active_requirement_orders: "Aktiv tələb sifarişləri",
    add_laboratory_service: "Laboratuvar xidməti əlavə edin",
    after_finished_fixed: "Bitirdikdən sonra",
    can_have_dental_work: "Diş işi olabilir",
    cannot_change_services_that_already_have_laboratory_services_attached: "Artıq onlarla əlaqəli laboratoriya işləri olan xidmətləri iş sifarişindən silə bilməzsiniz.",
    carcass: "Çərçivə",
    deleted_from_treatment: "Müalicədən çıxarıldı",
    delivery_date: "Çatdırılma tarixi",
    dental_work: "Diş işi",
    do_you_confirm_cancel_laboratory_order: "İş sifarişini ləğv etmək istədiyinizə əminsiniz?",
    do_you_confirm_laboratory_order_finish: "İşin xəstəyə təqdim edildiyini təsdiq edirsinizmi? Təsdiq edildikdən sonra həkimin maaşı hesablanacaq və bu iş əmrinə dəyişiklik etmək mümkün olmayacaq.",
    do_you_confirm_laboratory_order_finish2: "İşin xəstəyə təhvil verildiyini təsdiq edirsinizmi? Tamamlanmış iş sifarişinə dəyişiklik edilə bilməz. Redaktə etmək üçün sənədin dərcini ləğv etməlisiniz.",
    executor: "Yürütücü",
    faintly: "Zəif",
    field_is_required: "Sahə tələb olunur",
    fitting_date: "Uyğunlaşma tarixi",
    full: "Tam",
    immediately: "Dərhal",
    in_clinic: "Klinikada",
    in_lab: "Laboratoriyada",
    initiated: "Başlanğıc",
    intermediate_part_design: "Orta dizayn",
    laboratories: "Laboratuvarlar",
    laboratory: "Laboratuvar",
    laboratory_service: "Laboratoriya xidməti",
    LaboratoryOrder: "İş sifarişi",
    logics_on_laboratory_services_deduction: "Laboratoriya işini iş əmri ilə çıxmaq üçün məntiq",
    moderately: "Orta dərəcədə",
    must_have_dental_work: "Diş işi olmalıdır",
    no_dental_work_needed_for_selected_services: "Seçilen hizmetler için diş işi gerekli değil",
    no_services: "Xidmətlər yoxdur",
    order_number: "Sifariş nömrəsi",
    paint_restorations: "Bərpa işlərini ləkələyin",
    panorama: "Panorama",
    pay_all: "Hamısını ödə",
    requirement_order: "Gereklilik - sipariş",
    select_from_price: "Fiyattan seçin",
    send_to_laboratory_via_messenger: "Messenger vasitəsilə laboratoriyalara göndərin",
    shoulder: "Çiyin",
    simplified: "Sadələşdirilmiş",
    total_orders_for_the_amount: "Ümumi sifarişlər məbləği",
    when_changeing_laboratory_all_selected_services_will_be_removed_continue: "Laboratuvarı dəyişdirərkən seçilmiş bütün xidmətlər siyahıdan silinəcək. Davam et?",
    without_attachment_to_tooth: "Dişe bağlantısız"
}
